/*
 * @Author: Suroc
 * @Date: 2024-07-09 10:10:28
 * @LastEditTime: 2024-12-26 15:58:34
 * @Description: 全局设置
 */
import { defineStore } from 'pinia';
/**
 * @description 主题切换
 * @param {newTheme} 新的主题参数
 */
export const useThemeStore = defineStore('theme', {
  state: () => ({
    theme: localStorage.getItem('theme') || 'dark',  // 默认是 dark 主题
  }),
  actions: {
    setTheme(newTheme) {
      this.theme = newTheme;
      localStorage.setItem('theme', newTheme);
    },
  },
});
/**
 * @description 多语言切换
 * @param {newLocale} 新的语言参数
 */
export const useI18nStore = defineStore('i18nLocale', {
  state: () => ({
    i18nLocale: localStorage.getItem('i18nLocale') || 'en',  // 默认是英文
  }),
  actions: {
    setLocale(newLocale) {
      this.i18nLocale = newLocale;
      localStorage.setItem('i18nLocale', newLocale);
    },
  },
});
/**
 * @description 菜单
 * @param {nav} 菜单导航
 */
export const navStore = defineStore('activeNav', {
  state: () => ({
    activeNav: localStorage.getItem('activeNav') || 0,  // 默认是中文
  }),
  actions: {
    setNav(newNav) {
      this.activeNav = newNav;
      localStorage.setItem('activeNav', newNav);
    },
  },
});
/**
 * @description 多语言切换
 * @param {flag} 遮罩层是否可见
 * @param {params} 新的语言参数
 * @property {type} type - 类型-不同类型遮罩层
 *  质押成功        pledgeSuccess
 *  质押失败        pledgefailed
 *  暂未开发        notYetDev
 *  签到成功        signSuccess
 *  滑点            drawaDot
 *  滑点容差        markTolerance
 *  您将获得        youHaveObtain
 *  Loading等待中   loading
 */
export const userMaskStore = defineStore('mask', {
  state: () => ({
    isMaskVisible: false,   // 默认遮罩层不可见
    maskType: null,     // 用于存储自定义参数
    drwadot: 16, // 默认滑点
    setOptions: null, // 传输参数
    closeCallback: null,    // 关闭时的回调函数
  }),
  actions: {
    showMask(flag, type, options, callback) {
      this.isMaskVisible = flag;
      this.setOptions = options;
      if (flag) {
        this.maskType = type;
        this.closeCallback = callback; // 设置回调函数
      } else if (this.closeCallback) {
        this.closeCallback();          // 触发回调函数
        this.closeCallback = null;     // 清空回调函数
      }
    },
    setDrawaDot(val) {
      this.drwadot = null;
      this.drwadot = val;
    },
  },
});